import React from 'react';
import ReactDOM from 'react-dom';
import './shared/index.css';
import App from './App.web';
import * as serviceWorker from './serviceWorker';
import moduleAlias from 'module-alias'
import { Provider } from "react-redux";
import configureStore, { history } from "./shared/store/index.web";
import { ConnectedRouter } from "connected-react-router"
import { Route, Switch } from "react-router-dom";

moduleAlias.addAliases({ "react-native": require.resolve("react-native-web") });
const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/" component={App} />
            </Switch>
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
)

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register(null, global.IS_DEBUG);
serviceWorker.unregister()